
export default function Features() {
  const technologies = [
    {
      name: 'Swift Development',
      description: 'Native iOS development with latest Swift frameworks',
      image: 'https://public.readdy.ai/ai/img_res/449f0cea5080f83464a0ed481c4a96bb.jpg'
    },
    {
      name: 'Security Architecture',
      description: 'Advanced encryption and security protocols',
      image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20abstract%20encryption%20patterns%20glowing%20blue%20network%20connections%20and%20shield%20symbols%20representing%20cybersecurity%20and%20data%20protection%20in%20modern%20minimalist%20style%20with%20dark%20background&width=400&height=320&seq=tech-security-jamnik&orientation=landscape'
    },
    {
      name: 'UI/UX Design',
      description: 'Intuitive interfaces following iOS design guidelines',
      image: 'https://readdy.ai/api/search-image?query=Modern%20iOS%20app%20interface%20design%20mockups%20showing%20clean%20minimalist%20UI%20elements%20with%20soft%20gradients%20wireframes%20and%20user%20experience%20flow%20diagrams%20in%20light%20aesthetic%20with%20blue%20and%20purple%20accents&width=400&height=320&seq=tech-design-jamnik&orientation=landscape'
    },
    {
      name: 'Performance Optimization',
      description: 'Efficient code for smooth user experience',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20performance%20metrics%20with%20speed%20indicators%20graphs%20and%20optimization%20data%20flowing%20lines%20representing%20fast%20efficient%20mobile%20app%20performance%20in%20modern%20tech%20style%20with%20green%20and%20blue%20colors&width=400&height=320&seq=tech-performance-jamnik&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex justify-between items-start mb-20">
          <h2 className="text-5xl font-bold text-gray-900 max-w-md">
            Our Technology
          </h2>
          <p className="text-base text-gray-600 max-w-md leading-relaxed mt-4">
            Built with cutting-edge tools and frameworks
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="group relative rounded-2xl overflow-hidden bg-white border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer h-[280px]"
            >
              <div className="relative h-full">
                <img
                  src={tech.image}
                  alt={tech.name}
                  className="w-full h-full object-cover opacity-60"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-2">
                    {tech.name}
                  </h3>
                  <p className="text-sm text-white/80 leading-relaxed">
                    {tech.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}